import { navigate } from 'gatsby';
import Img from 'gatsby-image';
import React from 'react';
import { TeaserStoryblok } from '../../../_shared/interfaces/storyblok';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';
// @ts-ignore (no types available for 'gatsby-storyblok-image')
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';
import HsButton from '../hs-button/hs-button';
import { getMultilinkURL, isRichText } from '../../../lib/helpers/helpers';

import * as TeaserStyles from './teaser.module.scss';

const Teaser = ({ blok, storyblokCommon }: { blok: TeaserStoryblok; storyblokCommon: StoryblokCommon }) => {
    const [images, setImages] = React.useState<any[]>([]);

    const onButtonClick = (link: any) => {
        const url = getMultilinkURL(link);
        if (link.linktype === 'story') {
            navigate(url);
        } else if (link.linktype === 'url') {
            window.open(url);
        }
    };

    React.useEffect(() => {
        const imageList = [];
        if (blok.image_mobile && blok.image_mobile.filename) {
            imageList.push({ ...getFluidGatsbyImage(blok.image_mobile.filename), media: '(max-width: 767px)' });
        }
        if (blok.image_desktop && blok.image_desktop.filename) {
            imageList.push({ ...getFluidGatsbyImage(blok.image_desktop.filename), media: '(min-width: 768px)' });
        }
        setImages(imageList);
    }, [blok]);

    return (
        <div
            className={TeaserStyles.teaser}
            style={{ backgroundColor: blok.background_color?.color ?? '', padding: blok.padding ? '0 80px' : undefined }}
        >
            {images.length > 0 && (
                <div className={TeaserStyles.imageWrapper}>
                    <Img fluid={images} alt={blok.background_desktop?.alt ?? ''} />

                    {blok.image_overlay !== 'none' && (
                        <div className={[TeaserStyles.cover, TeaserStyles[blok.image_overlay ?? '']].join(' ')} />
                    )}
                </div>
            )}

            <div
                className={[
                    TeaserStyles.inner,
                    images.length ? TeaserStyles.innerWithImage : '',
                    blok.alignment === 'left' ? TeaserStyles.alignLeft : TeaserStyles.alignRight,
                ].join(' ')}
            >
                {isRichText(blok.richheadline) ? (
                    <div style={{ color: blok.text_color }} dangerouslySetInnerHTML={getRichTextMarkup(blok.richheadline)} />
                ) : (
                    blok.headline && <h1 style={{ color: blok.text_color }}>{blok.headline}</h1>
                )}
                {blok.copytext && <p style={{ color: blok.text_color }}>{blok.copytext}</p>}

                {blok.button_text && blok.button_link && (
                    <div className={TeaserStyles.button}>
                        <HsButton storyblokCommon={storyblokCommon} onClick={() => onButtonClick(blok.button_link)}>
                            {blok.button_text}
                        </HsButton>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Teaser;
